'use client';
 
import React from "react";
import dynamic from "next/dynamic";
import LazyOnVisible from "@/components/shared/LazyOnVisible";

const SampleAppSection = dynamic(
  () => import("./SampleApp"),
  { ssr: false }
);
const PlatformSection = dynamic(
  () => import("./Platform"),
  { ssr: false }
);
const PersuadeSection = dynamic(
  () => import("./Persuade"),
  { ssr: false }
);
const RecentWorksSection = dynamic(
  () => import("./RecentWorks"),
  { ssr: false }
);
const BlogsSection = dynamic(
  () => import("./BlogsSection"),
  { ssr: false }
);
const UserTestimonialsWrapper = dynamic(
  () => import("../wrapper/components/UserTestimonialsWrapper"),
  { ssr: false }
);
const AppFlowWrapper = dynamic(
  () => import("../wrapper/AppFlowWrapper"),
  { ssr: false }
);
const GallerySectionWrapper = dynamic(
  () => import("../wrapper/components/GallerySectionWrapper"),
  { ssr: false }
);

export default function ClientLandingSections() {
  return (
    <>
      <LazyOnVisible rootMargin="300px 0px" minHeight={560}>
        <SampleAppSection />
      </LazyOnVisible>
      <LazyOnVisible rootMargin="300px 0px" minHeight={600}>
        <PlatformSection />
      </LazyOnVisible>
      <LazyOnVisible rootMargin="300px 0px" minHeight={380}>
        <PersuadeSection />
      </LazyOnVisible>
      <LazyOnVisible rootMargin="300px 0px" minHeight={490} className="w-full overflow-hidden">
        <RecentWorksSection />
      </LazyOnVisible>
      <LazyOnVisible
        rootMargin="300px 0px"
        className="relative overflow-hidden px-0 py-5 dark:text-[#c1c6cf] md:px-10 md:py-10"
        minHeight={420}
      >
        <UserTestimonialsWrapper />
      </LazyOnVisible>
      <LazyOnVisible rootMargin="300px 0px" minHeight={520}>
        <AppFlowWrapper />
      </LazyOnVisible>
      <LazyOnVisible rootMargin="300px 0px" minHeight={450} className="relative overflow-hidden">
        <BlogsSection />
      </LazyOnVisible>
      <LazyOnVisible rootMargin="300px 0px" minHeight={520}>
        <GallerySectionWrapper />
      </LazyOnVisible>
    </>
  );
}

